// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChartStatusLine Styles */
.sPzFCchi3pq8cequ39K_ {
	position: absolute;
	z-index: 25;
	pointer-events: none;
	user-select: none;
	display: flex;
	flex-direction: column;
	gap: 2px;
	font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
	font-size: 11px;
	line-height: 16px;
}

.mfnMVUoP5IrEtHLeVr8a {
	display: inline-flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	pointer-events: auto;
	padding: 2px 6px;
	border-radius: 4px;
	/* V-06: scrim 0.8 so wicks never cut through figures (was 0.45). */
	background: rgba(18, 24, 38, 0.8);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	transition: background 0.15s ease;
	max-width: calc(100vw - 120px);
}

.WsaScJAOBbRONTDyDNZr {
	background: rgba(255, 255, 255, 0.85);
	border: 1px solid rgba(0, 0, 0, 0.06);
}

.rkU2Z1HIJY36WPeVPF8Y {
	background: rgba(18, 24, 38, 0.85);
	border: 1px solid rgba(255, 255, 255, 0.05);
}

.mfnMVUoP5IrEtHLeVr8a:hover {
	background: rgba(18, 24, 38, 0.92);
}

.WsaScJAOBbRONTDyDNZr:hover {
	background: rgba(255, 255, 255, 0.95);
}

.r2WkePXkMXD5EGAKM8PV {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	padding: 4px;
	background: transparent;
	border: none;
	border-radius: 3px;
	color: var(--vnsc-text-secondary, #94a3b8);
	cursor: pointer;
	transition: transform 0.2s ease, color 0.15s ease;
}

.r2WkePXkMXD5EGAKM8PV:hover {
	color: var(--vnsc-text-primary, #f8fafc);
	background: rgba(255, 255, 255, 0.08);
}

.qrPGS89Xp99rmUDPp2pw {
	transform: rotate(-90deg);
}

.fNz3MRVnkLauU7foFGLq {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-weight: 700;
	font-size: 11.5px;
	color: var(--vnsc-text-primary, #f8fafc);
}

.D6M2rCKWSw5qmlwNt0V6 {
	padding: 1px 4px;
	border-radius: 3px;
	font-size: 9px;
	font-weight: 700;
	text-transform: uppercase;
	background: rgba(255, 255, 255, 0.1);
	color: var(--vnsc-text-secondary, #94a3b8);
	letter-spacing: 0.04em;
}

.aeGPbCTCmist_Qo2VQAz {
	font-weight: 500;
	color: var(--vnsc-text-secondary, #94a3b8);
	font-size: 11px;
}

.ZArgfIFZxu8zq9B3sWny {
	display: inline-flex;
	align-items: center;
	gap: 2px;
	opacity: 0.25;
	transition: opacity 0.15s ease;
	flex-shrink: 0;
}

.mfnMVUoP5IrEtHLeVr8a:hover .ZArgfIFZxu8zq9B3sWny {
	opacity: 1;
}

.pqucN1tj3H7gyuTQVVzR {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	padding: 4px;
	background: transparent;
	border: none;
	border-radius: 3px;
	color: var(--vnsc-text-secondary, #94a3b8);
	cursor: pointer;
	font-size: 11px;
	transition: color 0.15s, background 0.15s;
}

.pqucN1tj3H7gyuTQVVzR:hover {
	color: var(--vnsc-text-primary, #f8fafc);
	background: rgba(255, 255, 255, 0.12);
}

.GTtB4Q13gEftt6yUmSns {
	display: inline-flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	font-family: var(--gc-mono, "SF Mono", Monaco, Inconsolata, "Roboto Mono", monospace);
	font-size: 10.5px;
	font-variant-numeric: tabular-nums;
}

.vI_G2Qqm9CHKFmBpAdmy {
	color: var(--vnsc-text-secondary, #94a3b8);
	margin-right: 2px;
}

.BWK257t3MMdDVdSgFdG9 {
	color: var(--vnsc-color-bullish, #26a69a) !important;
}

._6ejOP_waqwRvekStfXWz {
	color: var(--vnsc-color-bearish, #ef5350) !important;
}

.VFgFUrpvnEhsNBa0HHsT {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	pointer-events: auto;
	padding: 1px 6px;
	border-radius: 4px;
	font-size: 10px;
	line-height: 14px;
	/* UI-P2A: 4 action buttons must never widen the row past the chart edge
	   (the parent row is viewport-clamped; a 2x2/single cell is narrower). */
	max-width: 100%;
	min-width: 0;
	color: var(--vnsc-text-secondary, #94a3b8);
}

/* UI-P2A: per-row actions stay quiet until hover/focus, but the row must
   still be reachable by keyboard (focus-within), not hover-only. */
.VFgFUrpvnEhsNBa0HHsT .ZArgfIFZxu8zq9B3sWny {
	opacity: 0.25;
}

.VFgFUrpvnEhsNBa0HHsT:hover .ZArgfIFZxu8zq9B3sWny,
.VFgFUrpvnEhsNBa0HHsT:focus-within .ZArgfIFZxu8zq9B3sWny {
	opacity: 1;
}

.gL9ySTYCPlQb5g2t0ZGn {
	opacity: 0.6;
}

/* UI-P2A: "..." bulk menu. Portaled (S9) so the canvas surface never clips it. */
.XhP4oY6vGCpGjMWNaTN4 {
	position: fixed;
	z-index: var(--vnsc-z-maximum, 9999);
	display: flex;
	flex-direction: column;
	min-width: 156px;
	padding: 4px;
	border-radius: 6px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-primary, #0a0e14);
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.o4KttaVtbS6VnzICTywG {
	display: flex;
	align-items: center;
	width: 100%;
	padding: 5px 8px;
	border: none;
	border-radius: 4px;
	background: transparent;
	color: var(--vnsc-text-primary, #f8fafc);
	font-size: 11px;
	text-align: left;
	cursor: pointer;
}

.o4KttaVtbS6VnzICTywG:hover:not(:disabled) {
	background: rgba(255, 255, 255, 0.08);
}

.o4KttaVtbS6VnzICTywG:disabled {
	opacity: 0.4;
	cursor: default;
}

.Mb_1BfDS_lptx0_ZPsbf {
	color: var(--vnsc-color-bearish, #ef5350);
}

`, "",{"version":3,"sources":["webpack://./src/widget/components/canvas/ChartStatusLine.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;CACC,kBAAkB;CAClB,WAAW;CACX,oBAAoB;CACpB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,qFAAqF;CACrF,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,eAAe;CACf,QAAQ;CACR,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,mEAAmE;CACnE,iCAAiC;CACjC,0BAA0B;CAC1B,kCAAkC;CAClC,iCAAiC;CACjC,8BAA8B;AAC/B;;AAEA;CACC,qCAAqC;CACrC,qCAAqC;AACtC;;AAEA;CACC,kCAAkC;CAClC,2CAA2C;AAC5C;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,0CAA0C;CAC1C,eAAe;CACf,iDAAiD;AAClD;;AAEA;CACC,wCAAwC;CACxC,qCAAqC;AACtC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,iBAAiB;CACjB,wCAAwC;AACzC;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,oCAAoC;CACpC,0CAA0C;CAC1C,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,0CAA0C;CAC1C,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,0CAA0C;CAC1C,eAAe;CACf,eAAe;CACf,yCAAyC;AAC1C;;AAEA;CACC,wCAAwC;CACxC,qCAAqC;AACtC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,eAAe;CACf,QAAQ;CACR,qFAAqF;CACrF,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC,0CAA0C;CAC1C,iBAAiB;AAClB;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB;0EACyE;CACzE,eAAe;CACf,YAAY;CACZ,0CAA0C;AAC3C;;AAEA;mEACmE;AACnE;CACC,aAAa;AACd;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC,YAAY;AACb;;AAEA,iFAAiF;AACjF;CACC,eAAe;CACf,oCAAoC;CACpC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,6CAA6C;CAC7C,2CAA2C;CAC3C,0CAA0C;AAC3C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,wCAAwC;CACxC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,yCAAyC;AAC1C","sourcesContent":["/* ChartStatusLine Styles */\r\n.statusLineContainer {\r\n\tposition: absolute;\r\n\tz-index: 25;\r\n\tpointer-events: none;\r\n\tuser-select: none;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 2px;\r\n\tfont-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n\tfont-size: 11px;\r\n\tline-height: 16px;\r\n}\r\n\r\n.statusRow {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px;\r\n\tpointer-events: auto;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: 4px;\r\n\t/* V-06: scrim 0.8 so wicks never cut through figures (was 0.45). */\r\n\tbackground: rgba(18, 24, 38, 0.8);\r\n\tbackdrop-filter: blur(4px);\r\n\t-webkit-backdrop-filter: blur(4px);\r\n\ttransition: background 0.15s ease;\r\n\tmax-width: calc(100vw - 120px);\r\n}\r\n\r\n.statusRowLight {\r\n\tbackground: rgba(255, 255, 255, 0.85);\r\n\tborder: 1px solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.statusRowDark {\r\n\tbackground: rgba(18, 24, 38, 0.85);\r\n\tborder: 1px solid rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.statusRow:hover {\r\n\tbackground: rgba(18, 24, 38, 0.92);\r\n}\r\n\r\n.statusRowLight:hover {\r\n\tbackground: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.collapseBtn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tpadding: 4px;\r\n\tbackground: transparent;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tcursor: pointer;\r\n\ttransition: transform 0.2s ease, color 0.15s ease;\r\n}\r\n\r\n.collapseBtn:hover {\r\n\tcolor: var(--vnsc-text-primary, #f8fafc);\r\n\tbackground: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.collapseBtnCollapsed {\r\n\ttransform: rotate(-90deg);\r\n}\r\n\r\n.symbolBadge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tfont-weight: 700;\r\n\tfont-size: 11.5px;\r\n\tcolor: var(--vnsc-text-primary, #f8fafc);\r\n}\r\n\r\n.exchangeTag {\r\n\tpadding: 1px 4px;\r\n\tborder-radius: 3px;\r\n\tfont-size: 9px;\r\n\tfont-weight: 700;\r\n\ttext-transform: uppercase;\r\n\tbackground: rgba(255, 255, 255, 0.1);\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tletter-spacing: 0.04em;\r\n}\r\n\r\n.timeframeTag {\r\n\tfont-weight: 500;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tfont-size: 11px;\r\n}\r\n\r\n.actionsGroup {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 2px;\r\n\topacity: 0.25;\r\n\ttransition: opacity 0.15s ease;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.statusRow:hover .actionsGroup {\r\n\topacity: 1;\r\n}\r\n\r\n.actionBtn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tpadding: 4px;\r\n\tbackground: transparent;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tcursor: pointer;\r\n\tfont-size: 11px;\r\n\ttransition: color 0.15s, background 0.15s;\r\n}\r\n\r\n.actionBtn:hover {\r\n\tcolor: var(--vnsc-text-primary, #f8fafc);\r\n\tbackground: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.ohlcValues {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px;\r\n\tfont-family: var(--gc-mono, \"SF Mono\", Monaco, Inconsolata, \"Roboto Mono\", monospace);\r\n\tfont-size: 10.5px;\r\n\tfont-variant-numeric: tabular-nums;\r\n}\r\n\r\n.label {\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tmargin-right: 2px;\r\n}\r\n\r\n.bullish {\r\n\tcolor: var(--vnsc-color-bullish, #26a69a) !important;\r\n}\r\n\r\n.bearish {\r\n\tcolor: var(--vnsc-color-bearish, #ef5350) !important;\r\n}\r\n\r\n.indicatorRow {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpointer-events: auto;\r\n\tpadding: 1px 6px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 10px;\r\n\tline-height: 14px;\r\n\t/* UI-P2A: 4 action buttons must never widen the row past the chart edge\r\n\t   (the parent row is viewport-clamped; a 2x2/single cell is narrower). */\r\n\tmax-width: 100%;\r\n\tmin-width: 0;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n/* UI-P2A: per-row actions stay quiet until hover/focus, but the row must\r\n   still be reachable by keyboard (focus-within), not hover-only. */\r\n.indicatorRow .actionsGroup {\r\n\topacity: 0.25;\r\n}\r\n\r\n.indicatorRow:hover .actionsGroup,\r\n.indicatorRow:focus-within .actionsGroup {\r\n\topacity: 1;\r\n}\r\n\r\n.indicatorRowHidden {\r\n\topacity: 0.6;\r\n}\r\n\r\n/* UI-P2A: \"...\" bulk menu. Portaled (S9) so the canvas surface never clips it. */\r\n.actionsMenu {\r\n\tposition: fixed;\r\n\tz-index: var(--vnsc-z-maximum, 9999);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tmin-width: 156px;\r\n\tpadding: 4px;\r\n\tborder-radius: 6px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tbox-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.actionsMenuItem {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\tpadding: 5px 8px;\r\n\tborder: none;\r\n\tborder-radius: 4px;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-primary, #f8fafc);\r\n\tfont-size: 11px;\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n}\r\n\r\n.actionsMenuItem:hover:not(:disabled) {\r\n\tbackground: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.actionsMenuItem:disabled {\r\n\topacity: 0.4;\r\n\tcursor: default;\r\n}\r\n\r\n.actionsMenuItemDanger {\r\n\tcolor: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusLineContainer": `sPzFCchi3pq8cequ39K_`,
	"statusRow": `mfnMVUoP5IrEtHLeVr8a`,
	"statusRowLight": `WsaScJAOBbRONTDyDNZr`,
	"statusRowDark": `rkU2Z1HIJY36WPeVPF8Y`,
	"collapseBtn": `r2WkePXkMXD5EGAKM8PV`,
	"collapseBtnCollapsed": `qrPGS89Xp99rmUDPp2pw`,
	"symbolBadge": `fNz3MRVnkLauU7foFGLq`,
	"exchangeTag": `D6M2rCKWSw5qmlwNt0V6`,
	"timeframeTag": `aeGPbCTCmist_Qo2VQAz`,
	"actionsGroup": `ZArgfIFZxu8zq9B3sWny`,
	"actionBtn": `pqucN1tj3H7gyuTQVVzR`,
	"ohlcValues": `GTtB4Q13gEftt6yUmSns`,
	"label": `vI_G2Qqm9CHKFmBpAdmy`,
	"bullish": `BWK257t3MMdDVdSgFdG9`,
	"bearish": `_6ejOP_waqwRvekStfXWz`,
	"indicatorRow": `VFgFUrpvnEhsNBa0HHsT`,
	"indicatorRowHidden": `gL9ySTYCPlQb5g2t0ZGn`,
	"actionsMenu": `XhP4oY6vGCpGjMWNaTN4`,
	"actionsMenuItem": `o4KttaVtbS6VnzICTywG`,
	"actionsMenuItemDanger": `Mb_1BfDS_lptx0_ZPsbf`
};
export default ___CSS_LOADER_EXPORT___;
